import { render, staticRenderFns } from "./CampaignGroupGridFooter.vue?vue&type=template&id=2e5fa95f"
import script from "./CampaignGroupGridFooter.vue?vue&type=script&lang=js"
export * from "./CampaignGroupGridFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports